import EmailLeadForm from './EmailLeadForm/EmailLeadForm';
import EmployerLeadForm from './EmployerLeadForm/EmployerLeadForm';
import ZipEmailLeadForm from './ZipEmailLeadForm/ZipEmailLeadForm';

type Props = {
    formtype: string;
    leadtype: string;
    fixedallianceid: string;
    ctacopy: string;
};

const LeadForm = (props: Props) => {
    switch (true) {
        case props.formtype === 'employer-and-individual':
            return <EmployerLeadForm {...props} />;
        case props.formtype === 'ifp-state':
            return <ZipEmailLeadForm {...props} />;
        default:
            return <EmailLeadForm {...props} />;
    }
};

export default LeadForm;
